import { Load } from 'api';

import { useAllDealLoads } from '../useAllDealLoads/useAllDealLoads';

const isInspectionMatch = (load: Load, inspectionId: number) => load.inspection_id === inspectionId;

const isAssignedToInspection = (load: Load) => load.inspection_id;
export const useInspectionLoadByAssignment = (inspectionId: number, dealId: number) => {
  const { data: loads, isLoading } = useAllDealLoads(dealId);

  const assignedLoads = loads?.data.filter(
    (load) => isAssignedToInspection(load) && isInspectionMatch(load, inspectionId)
  );
  const unassignedLoads = loads?.data.filter((load) => !isAssignedToInspection(load));

  const otherInspectionsLoads = loads?.data.filter(
    (load) => isAssignedToInspection(load) && !isInspectionMatch(load, inspectionId)
  );

  return { assignedLoads, isLoading, otherInspectionsLoads, unassignedLoads };
};
